import React from "react";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import "./limitationsyourhoices.scss";

const LimitationsYourChoicesModal = (props) => {
  return (
    <div className="limitations-your-choices">
      {props.headTitle === "Transfer initiated" ? (
        <div></div>
      ) : (
        <div className="text-end">
          <Icons
            iconname="close-large"
            variant="icon-sixteen-px"
            clickHandler={props.handleCloseButton}
          />
        </div>
      )}

      <div className="heading">
        {props.iconTik ? (
          <div className={props.txtStyle}>
            {" "}
            <Icons iconname={props.iconTik} variant="icon-sixty-px" />
          </div>
        ) : (
          ""
        )}
        <p className={props.txtStyle}> {props.headTitle}</p>
      </div>

      <div className="sub-text">
        <p>{props.description}</p>
        <p>{props.descriptionOne}</p>
        <p>{props.descriptionTwo}</p>
        {props.subDescription ? <p>{props.subDescription}</p> : ""}
        {props.question ? <h3 className="mt-4">{props.question}</h3> : ""}
      </div>
      <div className="button-section mb-3">
        <div className="btn-section">
          <Buttons
            className="tertiary"
            name={props.btnCancelName}
            handleClick={props.btnCancelName}
          />
        </div>
        <div className="btn-section">
          <Buttons
            className="tertiary otherbtn"
            name={props.btnUserOtherName}
            handleClick={props.handleTimeline}
          />
        </div>
        <div className="btn-right">
          <Buttons
            className="primary"
            name={props.btnContinuedName}
            handleClick={props.handleClick}
          />
        </div>
      </div>
    </div>
  );
};

export default LimitationsYourChoicesModal;
